import type { z } from 'zod';

import { createVersionedFeature } from '../create-versioned-feature';
import { animationV0Schema } from './v0';

export const animationFeature = createVersionedFeature({
    versionMap: {
        0: { schema: animationV0Schema },
    },
    latestVersion: 0,
    createDefault: (): z.output<typeof animationV0Schema> => ({
        version: 0,
        isActive: false,
        animationType: 'fade',
        animationPosition: 'left',
        animationSpeed: 'medium',
    }),
});

export type AnimationSettings = z.output<typeof animationFeature.latestSchema>;
export type AnimationType = AnimationSettings['animationType'];
export type AnimationPosition = AnimationSettings['animationPosition'];
export type AnimationSpeed = AnimationSettings['animationSpeed'];

export { animationV0Schema };

export { animationOpacityVar } from './animation.css-vars';
